import { render, staticRenderFns } from "./OpportunitySelector.vue?vue&type=template&id=1cb2784f"
import script from "./OpportunitySelector.vue?vue&type=script&lang=ts"
export * from "./OpportunitySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports